import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IUserCrud } from "../interfaces/ilogin";
import { UserService } from "../services/user.service";
import { Observable } from "rxjs";

@Injectable()
export class UserResolver implements Resolve<IUserCrud> {
    constructor(private userService: UserService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IUserCrud> {
        return this.userService.getUser(route.params["id"]);
    }
}
